import { type CanvasElementDefinition } from '../../canvas-elements/element-definition';

import { getIoConfig } from './_base-chart.element';
import { getDefaults, getInitial, getPropsConfig } from './_base-round-chart.element';
import { PieChartElementHandler } from './ai/pie-chart.element-handler';
import { PieChartDefinitionMapper } from './ai/round-chart.definition-mapper';
import { ChartComponent } from './chart.component';
import { CHART_DIMENSIONS } from './chart.models';
import { ChartPropsBuilder } from './chart.props-builder';
import { ChartPropsExtractor } from './chart.props-extractor';
import { chartV2Migration } from './migrations/002-all-chart-types.migration';
import { chartV3Migration } from './migrations/003-chart.migration';

export function getPieChartDefinition(): CanvasElementDefinition<'chartPie'> {
  return {
    type: 'chartPie',
    componentType: ChartComponent<'chartPie'>,
    isListed: true,
    name: 'Pie Chart',
    width: { mode: 'value', value: CHART_DIMENSIONS.width, fixed: true },
    height: { mode: 'value', value: CHART_DIMENSIONS.height, fixed: true },
    ioConfig: getIoConfig(),
    propsConfig: getPropsConfig('chartPie'),
    propsBuilder: ChartPropsBuilder,
    propsExtractor: ChartPropsExtractor,
    defaults: getDefaults('Pie Chart', 'chartPie'),
    initial: getInitial(),
    groups: ['charts'],
    styleIncludePaths: [
      'style',
      'content.font.fontFamily',
      'content.font.style',
      'content.font.fontSize',
      'content.title.iconPosition',
    ],
    features: {
      ai: {
        showAiPromptAutomatically: true,
        description: true,
      },
      visualStyle: 'block',
    },
    version: 3,
    migrations: {
      2: chartV2Migration,
      3: chartV3Migration,
    },
    ai: {
      name: 'chartPie',
      handler: () => PieChartElementHandler,
      definitionMapper: () => PieChartDefinitionMapper,
    },
  };
}
